import { Form } from 'react-bootstrap'
import { Auth0Role } from '@black-bear-energy/black-bear-energy-common'

interface IRoleSelectPropTypes {
  onChange: (value: Auth0Role) => void
  value?: Auth0Role
  disabled: boolean
}

export default function RoleSelect({
  onChange,
  value,
  disabled,
}: IRoleSelectPropTypes) {
  function handleRoleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value as Auth0Role)
  }

  return (
    <fieldset>
      <legend className="required">User Role</legend>
      <Form.Group className="fluid">
        <Form.Check type="radio" name="user-role">
          <Form.Check.Label>
            <Form.Check.Input
              type="radio"
              name="user-role"
              value={Auth0Role.ADMIN}
              checked={value === Auth0Role.ADMIN}
              onChange={handleRoleChange}
              disabled={disabled}
            />
            {Auth0Role.ADMIN}
          </Form.Check.Label>
        </Form.Check>
        <Form.Check type="radio">
          <Form.Check.Label>
            <Form.Check.Input
              type="radio"
              name="user-role"
              value={undefined}
              checked={value === undefined}
              onChange={handleRoleChange}
              disabled={disabled}
            />
            User
          </Form.Check.Label>
        </Form.Check>
      </Form.Group>
    </fieldset>
  )
}
